import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HeroHomeComponent } from '../hero-home/hero-home.component';
import { HomeModulosComponent } from './home-modulos/home-modulos.component';
import { HomePreciosComponent } from './home-precios/home-precios.component';
import { OtrosServiciosComponent } from '../otros-servicios/otros-servicios.component';
import { ClientesProyectosComponent } from '../clientes-proyectos/clientes-proyectos.component';
import { PorQueNosotrosComponent } from '../por-que-nosotros/por-que-nosotros.component';
import { RevealDirective } from '../../directives/reveal.directive';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    RouterLink,
    HeroHomeComponent,
    HomeModulosComponent,
    HomePreciosComponent,
    OtrosServiciosComponent,
    ClientesProyectosComponent,
    PorQueNosotrosComponent,
    RevealDirective,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  /** Sectores para la trust strip (orden del diseño Híbrido v2). */
  sectores = [
    'Construcción',
    'Servicios técnicos',
    'Gestorías',
    'Comercio',
    'Trasteros',
    'Restauración',
  ];
}
